import { useCallback } from "react";
import { useLogger } from "@/utils/loggerService";
import { setDisplaySize } from "@/store/layoutSlice";
import { useDispatch } from "react-redux";
/**
 * DisplaySize
 */
export var DisplaySize;
(function (DisplaySize) {
    DisplaySize["SMALL"] = "SMALL";
    DisplaySize["MEDIUM"] = "MEDIUM";
    DisplaySize["LARGE"] = "LARGE";
    DisplaySize["XLARGE"] = "XLARGE";
    DisplaySize["X2LARGE"] = "X2LARGE";
})(DisplaySize || (DisplaySize = {}));
/**
 * Liste des breakpoints
 */
export var displayBreakpoints = [
    { size: DisplaySize.X2LARGE, query: "(min-width: 1536px)" },
    { size: DisplaySize.XLARGE, query: "(min-width: 1280px)" },
    { size: DisplaySize.LARGE, query: "(min-width: 1080px)" },
    { size: DisplaySize.MEDIUM, query: "(min-width: 768px)" },
    { size: DisplaySize.SMALL, query: "(min-width: 600px)" },
];
export function useDisplay(handler) {
    var logger = useLogger().logger;
    var dispatch = useDispatch();
    /*const queries: { query: MediaQueryList; breakpoint: DisplayBreakpoint }[] =
      [];*/
    var queries = displayBreakpoints.map(function (bp) { return ({
        breakpoint: bp,
        query: window.matchMedia(bp.query),
    }); });
    // Breakpoint change handler (MODERNE)
    var handleBreakpoints = useCallback(function () {
        // du plus grand au plus petit
        var active = queries.find(function (q) { return q.query.matches; });
        // si rien ne match → SMALL
        var size = active ? active.breakpoint.size : DisplaySize.SMALL;
        dispatch(setDisplaySize(size));
        if (handler)
            handler(active ? active.breakpoint : { size: DisplaySize.SMALL, query: "" });
        logger.debug("[Display] - Active size:", size);
    }, [dispatch, handler]);
    // Breakpoint change handler (OLD)
    var handleBreakpointsOld = useCallback(function () {
        /*const query = queries.reverse().find(({ query }) => query.matches);
        if (!query) {
          return;
        }*/
        // du plus large au plus petit
        var active = displayBreakpoints === null || displayBreakpoints === void 0 ? void 0 : displayBreakpoints.find(function (bp) { return window.matchMedia(bp.query).matches; });
        if (!active)
            return;
        dispatch(setDisplaySize(active.size));
        if (handler)
            handler(active);
    }, [dispatch, handler]);
    var attachEvents = function () {
        detachEvents();
        // Attach events
        logger.debug("[Display] - Attach BP event");
        displayBreakpoints.forEach(function (breakpoint) {
            var query = window.matchMedia(breakpoint.query);
            query.addEventListener("change", handleBreakpoints);
            queries.push({ query: query, breakpoint: breakpoint });
        });
        // First run
        handleBreakpoints();
    };
    var detachEvents = function () {
        displayBreakpoints.forEach(function (breakpoint) {
            var query = window.matchMedia(breakpoint.query);
            query.removeEventListener("change", handleBreakpoints);
        });
        logger.debug("[Display] - Detach BP event");
    };
    return { attachEvents: attachEvents, detachEvents: detachEvents };
}
